const VKEY = "kc_visitor_id";

const getVisitorId = () => {
  try {
    let id = localStorage.getItem(VKEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem(VKEY, id);
    }
    return id;
  } catch (e) {
    return "anon";
  }
};

export const trackPageview = (path) => {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;
    fetch(`${base}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        path: path || window.location.pathname,
        referrer: document.referrer || "",
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* noop */
  }
};
